var exports = {
  "kL": "Notifications.module__container___VVRQYn",
  "Wq": "Notifications.module__switchesContainer___VVRQYn",
  "_8": "Notifications.module__pushSection___VVRQYn",
  "Fm": "Notifications.module__pushHeading___VVRQYn",
  "p2": "Notifications.module__pushDescription___VVRQYn",
  "_j": "Notifications.module__pushButtons___VVRQYn",
  "zd": "Notifications.module__pushButton___VVRQYn",
  "Zo": "Notifications.module__pushButtonSecondary___VVRQYn",
  "pz": "Notifications.module__pushStatus___VVRQYn",
  "$r": "Notifications.module__pushList___VVRQYn",
  "MW": "Notifications.module__pushListItem___VVRQYn",
};

module.exports = exports;
